import axios_ from "../utils/axios";
export default {
  /**
   * 帖文主页列表
   * @param {*} param
   * @returns
   */
  getPostPagesLists(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/pagesLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 帖文列表
   * @param {*} param
   * @returns
   */
  getFBPosts(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/lists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 帖文评论列表
   * @param {*} param
   * @deprecated 请使用 `getCommentsList`
   * @returns
   */
  getFBPostsComments(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/commentsLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 绑定主页详情
   * @param {*} param
   * @returns
   */
  getPageDetail(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/getPageDetail`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 绑定/编辑 主页
   * @param {*} param
   * @returns
   */
  pageBindingStore(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/${param.id ? "update" : "insert"}`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 更新fb帖文-更新帖文
   * @param {*} param
   * @returns
   */
  uptFbPostsDatas(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/uptFbPostsDatas`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除绑定的主页
   * @param {*} param
   * @returns
   */
  pageBindingDel(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/del`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 更新管理员
   * @param {*} param
   * @returns
   */
  uptBotAdmin(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/addAdministrators`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除管理员
   * @param {*} param
   * @returns
   */
  delBotAdmin(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/delAdministrators`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 开启自动回复开关
   * @param {*} param
   * @returns
   */
  pageSwitchReply(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/updateReply`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 帖文下 评论列表
   * @param {*} param
   * @returns
   */
  getCommentsList(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/commentsLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 帖文下 评论 回复
   * @param {*} param
   * @returns
   */
  replyCommentHandle(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/replyComment`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除 帖文下 评论 回复
   * @param {*} param
   * @returns
   */
  deleteFbPostsComment(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/deleteFbPostsComment`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 隐藏 帖文下 评论 回复
   * @param {*} param
   * @returns
   */
  unhideComment(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/setCommentHide`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 帖文未回复的评论列表接口
   * @param {*} param
   * @returns
   */
  getCommentsNoReplyLists(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/commentsNoReplyLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 帖文机器人已隐藏和已删除评论列表接口
   * @param {Record<string,string|number>} param
   * @param {string} param.deal_type 1 隐藏评论 2 删除评论
   * @param {string} param.cs_id 客服id
   * @param {string} param.cs_type 客服类型 1 对话机器人 2 帖文机器人
   * @param {number} param.page 页码
   * @param {number} param.page_num 每页数量
   */
  postingCommentsLists(param) {
    return axios_("GET", "api/pandagpt/v1/fbPosts/postingCommentsLists", param);
  },
  /**
   * 帖文特定回复列表接口
   * @param {*} param
   * @returns
   */
  fbPostReplyLists(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/fbPostReplyLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 新增帖文特定回复
   * @param {*} param
   * @returns
   */
  createFbPostReply(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/createFbPostReply`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 有设置特定回复的帖文列表接口
   * @param {*} param
   * @returns
   */
  fbPostLists(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/fbPostLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 删除帖文特定回复接口
   * @param {*} param
   * @returns
   */
  delFbPostReply(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/delFbPostReply`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取客服下的管理员
   * @param {*} param
   * @returns
   */
  getBotAdministrators(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/getAdministrators`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 获取ins帖文列表
   * @param {Record<string,string|number>} param
   * @param {string} param.page_id 主页ID
   * @param {string} param.post_type 帖文类型 1 普通 2 广告
   * @param {number} param.page 页码
   * @param {number} param.page_num 每页数量，默认10条
   * @returns {Promise<*>}
   */
  getInsPostList(param) {
    // return axios_("GET",'api/pandagpt/v1/instagramData/posts/list',param, false, false, true)
    return axios_("GET", "pyinterface/instagramData/data/instagram/posts/list", param);
  },
  /**
   * 获取ins帖文详情
   * @param {string} post_id
   * @returns {Promise<*>}
   */
  getInsPostDetail(post_id) {
    // return axios_('GET','api/pandagpt/v1/instagramData/posts/details',{post_id}, false, false, true)
    return axios_("GET", "pyinterface/instagramData/data/instagram/posts/details", {
      post_id
    });
  },
  /**
   * 获取facebook帖文详情
   * @param post_id
   * @returns {Promise<axios.AxiosResponse<any>>}
   */
  getFbPostDetail(post_id) {
    return axios_("GET", "api/pandagpt/v1/fbPosts/getPostingDetail", {
      post_id
    });
  },
  /**
   * 删除ins评论
   * @param {string} comment_id
   * @returns {Promise<*>}
   */
  deleteInsComment(comment_id) {
    // return axios_('POST','api/pandagpt/v1/instagramData/comment/delete',{comment_id}, false, false, true)
    return axios_("POST", "pyinterface/instagramData/data/instagram/comment/delete", {
      comment_id
    });
  },
  /**
   * 获取ins评论列表
   * @param {Record<string,string|number>} param
   * @param {string} param.post_id
   * @param {string} param.issue_grade
   * @param {string} param.sort
   * @param {number} param.page
   * @param {number} param.page_num
   * @returns {Promise<*>}
   */
  getInsCommentList(param) {
    // return axios_('GET','api/pandagpt/v1/instagramData/comments/list',param, false, false, true)
    return axios_("GET", "pyinterface/instagramData/data/instagram/comments/list", param);
  },
  /**
   * ins 评论的隐藏和恢复
   * @param {string} comment_id 评论ID
   * @param {1|2} is_hide 是否隐藏评论 1 是 2 否
   * @returns {Promise<{code:number,msg:string,data:any}>}
   */
  hideInsComment(comment_id, is_hide) {
    // return axios_("POST","api/pandagpt/v1/instagramData/comment/hide",{comment_id, is_hide}, false, false, true)
    return axios_("POST", "pyinterface/instagramData/data/instagram/comment/hide", {
      comment_id,
      is_hide
    });
  },
  /**
   * INS 回复评论
   * @param {Record<string,any>} param
   * @param {string} param.comment_id
   * @param {string} param.page_id
   * @param {string} param.message
   * @param {string} param.post_id
   * @returns {Promise<{code:number,data:any,msg:string}>}
   */
  replyInsComment(param) {
    // return axios_("POST","api/pandagpt/v1/instagramData/comment/replyComment",param, false, false, true)
    return axios_("POST", "pyinterface/instagramData/data/instagram/comment/replyComment", param);
  },
  /**
   * 机器人关联平台列表
   * @param {*} param
   * @returns
   */
  getPlatformBindingLists(param) {
    return new Promise((resolve, reject) => {
      axios_("GET", `api/pandagpt/v1/fbPosts/getPlatformBindingLists`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 机器人关联平台
   * @param {*} param
   * @returns
   */
  platformBinding(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/platformBinding`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 机器人取消平台关联授权
   * @param {*} param
   * @returns
   */
  platformUnbind(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `api/pandagpt/v1/fbPosts/platformUnbind`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  /**
   * 更新Ins帖文
   * @param {*} param
   * @returns
   */
  uptInsPostsDatas(param) {
    return new Promise((resolve, reject) => {
      axios_("POST", `pyinterface/instagramData/data/uptPosts`, param).then(res => {
        resolve(res);
      }).catch(err => reject(err));
    });
  },
  //设置帖文特定回复是否自动运营
  updateAutoReply(param) {
    return axios_("POST", `api/pandagpt/v1/fbPosts/updatePostReply`, param);
  },
  //机器人 批量关联平台
  batchPlatformBinding(param) {
    return axios_("POST", `api/pandagpt/v1/fbPosts/batchPlatformBinding`, param);
  },
  /**
   * 获取未处理的评论
   * @param {{cs_id?:string;page_id?:string;page?:number; page_num?:number}} param
   * @returns {Promise<{code:number,data:any,msg:string}>}
   */
  getUntreatedComments(param) {
    return axios_("GET", `api/pandagpt/v1/fbPosts/getUntreatedComments`, param);
  },
  /**
   * 设置不回复
   * @param {string} cs_platform 平台 1 fb 2 ins
   * @param {string} comment_id 评论id
   * @returns {Promise<{code:number,data:any,msg:string}>}
   */
  setNotReply(cs_platform, comment_id) {
    return axios_("POST", "api/pandagpt/v1/fbPosts/setNotReply", {
      cs_platform,
      comment_id
    });
  }
};